import { render } from "./TechItsOurOfferingComp.vue?vue&type=template&id=5bd9d2ea&scoped=true"
import script from "./TechItsOurOfferingComp.vue?vue&type=script&lang=js"
export * from "./TechItsOurOfferingComp.vue?vue&type=script&lang=js"

import "./TechItsOurOfferingComp.vue?vue&type=style&index=0&id=5bd9d2ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd9d2ea"]])

export default __exports__